export const shouldRemoveTrailingZeroDecimals = (amount: number): boolean => {
  const decimalPart = amount % 1;
  if (decimalPart === 0 || amount === 0) {
    return true;
  }
  return false;
};
